export default "__VITE_ASSET__6db09546__"